import getCategories from '../service/categories';
import getPlaces from '../service/places';

import renderCategoryStyle from '../data/catstyles';

import decode from '../utilities/htmldecode';

import Superset from '../framework/collections/superset';

// https://stackoverflow.com/questions/23483718/turn-array-into-comma-separated-grammatically-correct-sentence
function toSentence( list ) {
	return list.slice( 0, -2 ).join( ', ' ) + ( list.slice( 0, -2 ).length ? ', ' : '' ) + list.slice( -2 ).join( ' & ' );
}

export default function( $, app ) {
	var $body = $( 'body' );

	var { views, model: session } = app;

	var categories = views.categoriesList.collection,
		venues = views.venuesList.collection;

	var foundVenues = new Superset( [], {
		subset: venues,
		libraries: { category: categories },
	} );

	// =========================
	// ! Session Venues
	// =========================

	function fetchVenues( callback ) {
		var type = session.get( 'request' ),
			ask = session.get( 'ask' ),
			mode = session.get( 'mode' ),
			origin = session.get( 'origin' ),
			destination = session.get( 'destination' ),
			start_time = session.get( 'start' ),
			end_time = session.get( 'end' ),
			date = session.get( 'date' );

		if ( type === 'ask' && ask ) {
			const request = {
				uid: app.id,
				tripId: session.getId(),
				text: ask,
			};

			getPlaces( request, resp => {
				console.log( resp );
			} );
		} else
		if ( origin && ( start_time || destination ) ) {
			const request = {
				uid: app.id,
				tripId: session.getId(),
				tripFrom: origin,
				tripDate: date,
				tripMode: mode,
				offset: session.method.get( 'radius' ),
			};

			session.set( 'type', type );

			if ( type === 'road' ) {
				request.tripTo = destination;
			}

			if ( type === 'area' ) {
				request.startTime = start_time;
				request.endTime = end_time;
			}

			getPlaces( request, ( { tripDate, data, tripDistance, polyline } ) => {
				data = data || [];

				$body.toggleClass( 'no-results', data.length === 0 );

				session.set( {
					type: ( ( polyline && polyline.coordinates[0].length > 1 ) ? 'road' : 'area' ),
					date: tripDate,
					distance: tripDistance,
					route: polyline,
				} );

				foundVenues.set( data.map( place => {
					var name = decode( place.name ),
						venue = decode( place.venue );

					// If venue and name are the same erase venue so it doesn't show twice
					if ( name.toLowerCase().replace( /\W+/, '-' ) === venue.toLowerCase().replace( /\W+/, '-' ) ) {
						venue = '';
					}

					if ( place.tags === '0' ) {
						place.tags = '';
					}

					return {
						id: place.id,
						name: name,
						venue: venue,
						category: place.category,
						date: place.date || '',
						time: place.time || '',
						endDate: place.endDate || '',
						endTime: place.endTime || '',
						description: decode( place.info ),
						address: decode( place.address ),
						website: place.url,
						rating: parseInt( place.rating || '0', 10 ),
						lat: parseFloat( place.latitude ),
						lng: parseFloat( place.longitude ),
						keywords: place.tags.trim(),
						isEvent: !! place.isEvent,
						isRecurring: !! place.isRecurring,
					};
				} ) );

				callback();
			} );

			return;
		}

		callback();
	}

	// =========================
	// ! Session Categories
	// =========================

	const categoryIcons = {
		2: 'paintbrush',
		3: 'ferriswheel',
		5: 'beerstein',
		6: 'child',
		7: 'camera',
		8: 'bag',
		9: 'hands',
		11: 'clouds',
		17: 'tech',
	};

	const categoryColors = {
		2: 'cyan',
		3: 'orange',
		5: 'pink',
		6: 'purple',
		7: 'beige',
		8: 'blue',
		9: 'teal',
		11: 'green',
		12: 'dark',
	};

	getCategories( results => {
		var items = results.filter( item => item.name !== 'unknown' );

		items.forEach( item => {
			item.name = toSentence( item.name.split( /\s*\/\s*/ ) );
			item.slug = `cat${item.id}`;

			item.icon = item.icon || categoryIcons[ item.id ];
			item.color = item.color || categoryColors[ item.id ];

			renderCategoryStyle( item );
		} );

		categories.set( items );
	} );

	function updateCategoryCounts() {
		var matchedVenues = foundVenues.withPredicate( 'withinArea' );

		categories.each( category => {
			category.set( 'count', matchedVenues.where( { category: category.id } ).length );
			category.set( 'venueCount', matchedVenues.where( { category: category.id, isEvent: false } ).length );
			category.set( 'eventCount', matchedVenues.where( { category: category.id, isEvent: true } ).length );
		} );

		categories.sort();
	}

	foundVenues.on( 'reset update', updateCategoryCounts );
	foundVenues.on( 'predicate:withinArea', updateCategoryCounts );

	// =========================
	// ! Expose to app object
	// =========================

	app.fetchVenues = fetchVenues;
	app.foundVenues = foundVenues;
}
